module.exports = __webpack_public_path__ + "static/media/AUTRE.748790ee.png";